module.exports = __webpack_public_path__ + "static/media/QuantityPlus.adc5a269.svg";